import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';
import { Language, ProductTranslation } from '../models/product-translation-data.models';

@Injectable({
  providedIn: 'root'
})
export class ProductTranslationDataService {
  constructor(private api: ApiService) {}
  private baseUrl = environment.apiUrl;

  getLanguages(): Observable<Language[]> {
    return this.api.get(
      `${this.baseUrl}/ProductTranslationData/languages`);
  }

  getData(productId: number): Observable<ProductTranslation> {
    return this.api.get(
      `${this.baseUrl}/ProductTranslationData/${productId}`);
  }

  updateData(productId: number, model: ProductTranslation): Observable<ProductTranslation> {
    return this.api.patch(
      `${this.baseUrl}/ProductTranslationData/${productId}`, model);
  }
}